/**
 * Season phases in workflow order: drafts are uploaded and locked before reviewers are matched (2026-10-19 spec §5.1).
 * The set must equal CK_Season_Phase in V052, which does not encode order (workflow.spec.ts).
 */
export const OEP_PHASES = [
    'Setup', 'Accepted', 'DraftUpload', 'DraftClosed', 'Matched', 'Reviewing',
    'FeedbackReleased', 'Nominating', 'Selecting', 'Complete',
] as const;
export type OEPPhase = (typeof OEP_PHASES)[number];

/** The prototype's four-stage season view (logic.js:14-19). */
export type OEPSeasonStage = 'sum' | 'nov' | 'dec' | 'jan';

const STAGE_BY_PHASE: Readonly<Record<OEPPhase, OEPSeasonStage>> = {
    Setup: 'sum', Accepted: 'sum',
    DraftUpload: 'nov', DraftClosed: 'nov', Matched: 'nov', Reviewing: 'nov',
    FeedbackReleased: 'dec', Nominating: 'dec',
    Selecting: 'jan', Complete: 'jan',
};

export function IsOEPPhase(value: string): value is OEPPhase {
    return (OEP_PHASES as readonly string[]).includes(value);
}

export function PhaseIndex(phase: OEPPhase): number {
    return OEP_PHASES.indexOf(phase);
}

export function IsPhaseAtLeast(current: OEPPhase, floor: OEPPhase): boolean {
    return PhaseIndex(current) >= PhaseIndex(floor);
}

export function StageOf(phase: OEPPhase): OEPSeasonStage {
    return STAGE_BY_PHASE[phase];
}
